import { Grid } from "@material-ui/core";
import React from "react"
import ProductCard from "../ProductCard";

const ProductsList = ({data, md, sm, elevation}) => {
    return(
        <Grid container>
						{data?.map((item) => {
							const { imageUrl, buttonTitle, title, description, tags } = item;
							return (
								<Grid xs={12} md={md} sm={sm}>
									<ProductCard
										cardContentTitle={title}
										relativeImage={imageUrl}
										cardMediaTitle={title}
										cardItemDes={description}
										buttonText={buttonTitle}
										elevation={elevation}
										cardContent={tags}
									/>
								</Grid>
							);
						})}
					</Grid>
    )
}

export default ProductsList